module.exports = __webpack_public_path__ + "static/media/tlyfwhite.1a6f98d5.png";